import o from'./../../../../ext-esm/style-inject/dist/style-inject.es.js';var e={container:"CursorPositioner_container__EC3AR"};o(".CursorPositioner_container__EC3AR{left:0;position:absolute;top:-16px;z-index:1}");export{e as default};
